import { useState, type ReactNode } from "react";
import { Button } from "./button";

/** The container, rather than the viewport, determines the number of pairs. */
export function PropertyList({ children }: { children: ReactNode }) {
  return <div className="avm-properties"><dl className="avm-properties__grid">{children}</dl></div>;
}

export function PropertyItem({ label, children, tone, inline = false, onAdd, missing = false }: {
  label: ReactNode;
  children: ReactNode;
  tone?: "warn" | "bad";
  inline?: boolean;
  onAdd?: () => void;
  missing?: boolean;
}) {
  const empty = children == null || children === "" || children === "—";
  return <div className={`avm-property${inline ? " avm-property--inline" : ""}${tone ? ` avm-property--${tone}` : ""}${missing ? " border-2 border-dashed border-[var(--color-status-bad-fg)] bg-[var(--color-status-bad-bg)] rounded-lg p-3" : ""}`}>
    <dt>{label}</dt><dd>{empty ? <span className="avm-property__empty">—{onAdd ? <> <button type="button" className="min-h-11 underline" aria-label={typeof label === "string" ? `${missing ? "Nedostaje – dopuni" : "Dodaj"}: ${label}` : undefined} onClick={onAdd}>{missing ? "Nedostaje – dopuni" : "Dodaj"}</button></> : missing ? " Nedostaje" : null}</span> : children}</dd>
  </div>;
}

export function PropertySection({ title, children, onEdit, editing, hint, badge }: {
  title: string; children: ReactNode; onEdit?: () => void; editing?: boolean; hint?: ReactNode;
  badge?: ReactNode;
}) {
  return <section aria-label={title} className="avm-property-section">
    <header><h2>{title}{badge != null && <span className="ml-2 rounded-full bg-[var(--color-status-bad-bg)] px-2 py-1 text-sm text-[var(--color-status-bad-fg)]">{badge}</span>}</h2>{onEdit && <Button variant="tertiary" size="sm" aria-label={`${editing ? "Zatvori uređivanje" : "Uredi"}: ${title}`} onClick={onEdit}>{editing ? "Zatvori uređivanje" : "Uredi"}</Button>}</header>
    {hint && <p className="avm-meta mb-3">{hint}</p>}{children}
  </section>;
}

export function CopyValue({ value, label, group = false }: { value: string; label: string; group?: boolean }) {
  const [message, setMessage] = useState("");
  return <span className="avm-copy-value"><span className="broj">{group ? value.replace(/\s/g, "").match(/.{1,4}/g)?.join(" ") : value}</span>
    <button type="button" className="avm-copy-value__button" aria-label={`Kopiraj ${label}`} onClick={async () => {
      try { await navigator.clipboard.writeText(value.replace(/\s/g, "")); setMessage("Kopirano"); }
      catch { setMessage("Kopiranje nije dostupno. Označite i kopirajte vrijednost."); }
    }}>Kopiraj</button><span role="status" className="avm-meta">{message}</span>
  </span>;
}
